<template lang="">
  <v-container fluid class="pt-0 px-0" align="center">
    <HomeHeader />
    <HomeHeaderMdSize />
    <v-row class="mx-4 mt-4">
      <v-col cols="12" sm="12" md="8" lg="9" xl="9" order-md="2" class="topics">
        <TopicSortTabs v-on:selectedTab="column = $event" />
        <TopicList :column="column" />
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" xl="3" order-md="1">
        <ContributorRankingTable />
        <TagRankingTable />
        <UsageUrlRankingTable />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import HomeHeader from "../organisms/HomeHeader.vue";
import HomeHeaderMdSize from "../organisms/HomeHeaderMdSize.vue";
import TopicList from "../organisms/TopicList/TopicList.vue";
import TopicSortTabs from "../organisms/TopicSortTabs.vue";
import ContributorRankingTable from "../organisms/ContributorRankingTable.vue";
import TagRankingTable from "../organisms/TagRankingTable.vue";
import UsageUrlRankingTable from "../organisms/UsageUrlRankingTable.vue";

export default {
  name: "HomeTemplate",
  components: {
    HomeHeader,
    HomeHeaderMdSize,
    TopicList,
    TopicSortTabs,
    ContributorRankingTable,
    TagRankingTable,
    UsageUrlRankingTable
  },
  data() {
    return {
      column: "-created_at",
    };
  },
};
</script>
<style lang="scss">
.topics {
  min-width: 280px;
  padding: 0 !important;
}
</style>
